<appTable v-if="shouldRenderConfig" v-show="getShowOptionsTable" :tableName="name"  v-bind:tableClass="getClassName">
    <slot></slot>
</appTable>


